import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function getLogs(params) {
  return BaseService.get(REST.LOGS, {
    params: paramsFilter({ params }),
  });
}

export default {
  getLogs,
};
